import { render, staticRenderFns } from "./PharmacyConfigs.vue?vue&type=template&id=a9d6943c&"
import script from "./PharmacyConfigs.vue?vue&type=script&lang=ts&"
export * from "./PharmacyConfigs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports